import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeControlSearchComponent } from './change-control-search/change-control-search.component';
import { BptSearchModule } from 'bpt-ui-library/bpt-search';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { EmptyResultsComponent } from '../shared-components/empty-results/empty-results.component';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';
import { ToastModule } from 'primeng/toast';
import { PanelHubComponent } from '../shared-components/panel-hub/panel-hub.component';
import { LabelComponent } from '../shared-components/label/label.component';



@NgModule({
  declarations: [
    ChangeControlSearchComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    BptSearchModule,
    TooltipModule,
    FormsModule,
    EmptyResultsComponent,
    SpinnerComponent,
    ToastModule,
    PanelHubComponent,
    LabelComponent
  ],
  exports: [
    ChangeControlSearchComponent
  ]
})
export class ChangeControlCatalogueModule { }
